<template>

  <a rel="nofollow" target="_blank" class="flex-row outlink" style="cursor: pointer">
    <div class="hotel-image" v-if="item.photos[0]">

        <span v-if="index > 2">

            <div class="image-container" v-lazy:background-image="item.photos[0].max300"></div>

        </span>

        <span v-else>

            <div class="image-container" :style="'background: url(\'' + item.photos[0].max300 + '\');'"></div>

        </span>

    </div>

    <div class="hotel-text">
      <div class="hotel-name">

        <div style="margin-right: 5px;">
          {{ item.actual?.name ?? item.name }}
        </div>


        <div class="hotel-desktop-stars">

            <div style="position: relative; display: inline-block; width: 70px; height: 13px; padding-bottom: 4px;">
                <img src="/images/star-bg.png" style="width: 70px; height: 13px;" alt="Hotel rating">
                <div style="overflow: hidden; position: absolute; top: 0;" :style="'width:' + item.class * 20 + '%'">
                    <img src="/images/star-fg.png" style="width: 70px; height: 13px; max-width: 70px;"  alt="Hotel rating">
                </div>
            </div>

        </div>

      </div>




      <div class="hotel-mobile-stars">

        <div style="position: relative; display: inline-block; width: 70px; height: 13px; padding-bottom: 4px;">
            <img src="/images/star-bg.png" style="width: 70px; height: 13px;" alt="Hotel rating">
            <div style="overflow: hidden; position: absolute; top: 0;" :style="'width:' + item.class * 20 + '%'">
                <img src="/images/star-fg.png" style="width: 70px; max-width: 70px; height: 13px;" alt="Hotel rating">
            </div>
        </div>

      </div>




      <div class="hotel-adress">
        {{ item.actual?.address ?? item.address }}
      </div>






      <div class="hotel-rating">

            <div>
                <span class="hotel-rating-review">{{ parseFloat(item.review_score) }} of 10 <span v-if="item.actual">"{{ item.actual?.review_score_word }}"</span></span>
            </div>

      </div>
      <div class="hotel-pros">
        <div v-if="item.actual?.direct_payment">

            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#22762d" class="bi bi-check2-circle" viewBox="0 0 16 16">
              <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/>
              <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>
            </svg>

            {{ translations.no_prepayment?.[languageCode] ?? 'No prepayment. Pay at property' }}</div>
      </div>
      <div class="hide-desktop">
        <div class="hotel-price" v-if="item.actual">
          {{ currency }} {{ Math.ceil(item.actual?.price)?.toLocaleString() }}
        </div>
        <div class="hotel-booker">
          Booking.com
        </div>
        <div class="hotel-button">
          <span class="submit">{{ translations.show_prices?.[languageCode] ?? 'Show prices' }}

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-chevron-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
            </svg>

          </span>
        </div>
      </div>
    </div>
    <div class="desktop-price">
      <div class="hotel-price" v-if="item.actual">
        {{ currency }} {{ Math.ceil(item.actual?.price)?.toLocaleString() }}
      </div>
      <div class="hotel-booker">
        Booking.com
      </div>
      <div class="hotel-button">
        <span class="submit">{{ translations.show_prices?.[languageCode] ?? 'Show prices' }}

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-chevron-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
            </svg>

        </span>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "Hotel",
  props: {
    item: Object,
    currency: String,
    index: Number,
    checkin: String,
    checkout: String
  },
  computed: {
    nights() {
      if(!this.checkin || !this.checkout) return 2;
      const startDate = new Date(this.checkin);
      const endDate = new Date(this.checkout);
      const differenceInMilliseconds = endDate - startDate;
      return differenceInMilliseconds / (1000 * 60 * 60 * 24);
    }
  },
  data() {
    return {
      translations: window.translations,
      languageCode: localStorage.getItem('locale') === 'en' ? 'us' : localStorage.getItem('locale'),
    }
  }
}
</script>

<style scoped>

</style>
